import React, { createContext, useMemo, useState} from "react";

export const PerguntaContext = createContext({});

export function PerguntaProvider({ children }) {
    const [listaPerguntas, setListaPerguntas] = useState([]);
    const [listaTipoRespostaPerguntas, setListaTipoRespostaPerguntas] = useState([]);

    const adicionarPergunta = (data) => {
        setListaPerguntas((current) => {
            return [data, ...current].sort((a,b)=> a.enunciado > b.enunciado ? 1 : -1);
        });
    };

    const atualizarPergunta = (data) => {
        setListaPerguntas((current) => {
            return current.map((pergunta) => {
                if (pergunta.id_pergunta === data.id_pergunta) {
                    return data;
                }
                return pergunta;
            });
        });
    };

    const removerPergunta = (idPergunta) => {
        setListaPerguntas((current) => {
            return current.filter(
                (pergunta) => pergunta.id_pergunta !== idPergunta
            );
        });
    };

    const values = useMemo(()=>{
      return {
        listaPerguntas,
        setListaPerguntas,
        listaTipoRespostaPerguntas,
        setListaTipoRespostaPerguntas,
        adicionarPergunta,
        atualizarPergunta,
        removerPergunta,
      }
    },[listaPerguntas, listaTipoRespostaPerguntas]);

    return (
        <PerguntaContext.Provider
            value={values}
        >
            {children}
        </PerguntaContext.Provider>
    );
}
